// extracted by mini-css-extract-plugin
export var container = "_ec-1";
export var cornerButtonContainer = "_ec-6";
export var disabled = "_ec-2";
export var dragActive = "_ec-3";
export var fileContainer = "_ec-5";
export var hiddenInput = "_ec-4";
export var widthContainer = "_ec-0";